import 'core-js/es6/array';
import 'core-js/es6/map';
import 'core-js/es6/weak-map';
import 'core-js/es6/set';
import 'raf/polyfill';

import React from 'react';
import moment from 'moment';
import 'moment/locale/ko';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Router } from 'react-router-dom';
import { unregister } from './registerServiceWorker';
import history from './history.js';
import store from './store';
import Root from './components/Root';
import { ScrollToTop } from './components/common';
import FontFaceObserver from 'fontfaceobserver';

moment.locale('ko');

if (window.location.hostname === 'tax-accountants.cashnote.kr') {
  window.analytics.ready(function() {
    /* eslint-disable no-undef */
    ga('require', 'linker');
    ga('linker:autoLink', ['app.cashnote.kr']);
  });
  window.analytics.load('ryI7MR6Zwyu8u8l543BP5SLGrvU9ltGn');
  window.analytics.page();
}

new FontFaceObserver('Spoqa Han Sans').load(null, 5 * 1000).then(() => {
  document.body.setAttribute('spoqa-han-sans-loaded', true);
});

const RouteDeliverer = ({ match, location, history }) => {
  return (
    <Provider store={store}>
      <ScrollToTop>
        <Root match={match} location={location} history={history} />
      </ScrollToTop>
    </Provider>
  );
};

import('./imports').then(() => {
  render(
    <Router history={history}>
      <Route path="/" component={RouteDeliverer} />
    </Router>,
    document.getElementById('root')
  );
  unregister();
});

if (process.env.NODE_ENV === 'production') {
  history.listen(() => window.analytics.page());
}



// WEBPACK FOOTER //
// ./src/index.js